// features/application/applicationSlice.ts
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Industry } from '../../types/types';

interface ApplicationState {
  industries: Industry[];
}

const initialState: ApplicationState = {
  industries: [],
};

const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    setIndustries(state, action: PayloadAction<Industry[]>) {
      state.industries = action.payload;
    },
    clearIndustries(state) {
      state.industries = [];
    },
  },
});

export const { setIndustries, clearIndustries } = applicationSlice.actions;

export default applicationSlice.reducer;
